export default __webpack_public_path__ + "static/media/main_nav_check_white.22be552b.svg";